var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70628 6.90861L1.0463 0.983476C0.921268 0.872207 0.718701 0.872207 0.593777 0.983476C0.468741 1.09465 0.468741 1.27501 0.593777 1.38618L2.31594 2.91724H1.31654C1.2282 2.91724 1.15659 2.98096 1.15659 3.05957V5.63515C1.15659 5.67286 1.17343 5.70909 1.20344 5.73579C1.23344 5.76249 1.27404 5.77748 1.31654 5.77748H2.91557C2.93977 5.78751 2.96242 5.80041 2.98272 5.81589L5.36365 7.65724C5.44351 7.71957 5.55617 7.73635 5.65444 7.70041C5.75282 7.66458 5.81975 7.5822 5.82733 7.4879V6.04212L7.2537 7.31143C7.37873 7.4226 7.5813 7.4226 7.70622 7.31143C7.83126 7.20026 7.83126 7.0199 7.70622 6.90873L7.70628 6.90861Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82729 1.22103C5.82874 1.20535 5.82874 1.18967 5.82729 1.17408C5.8052 1.08892 5.73438 1.02053 5.64091 0.993932C5.54733 0.96733 5.44504 0.986587 5.37165 1.04455L3.51038 2.46752L5.82729 4.52653V1.22103Z",
    fill: "#F0F0F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.5a384ca098bfb23b4121b8d770f081f5.svg";
export { ForwardRef as ReactComponent };